import SiteDetailContainer from '@components/containers/cmSites/SiteDetail';
import AppLayout from '@layouts/AppLayout';
import { type FC } from 'react';

const CmSiteDetail: FC = () => (
    <AppLayout>
        <SiteDetailContainer />
    </AppLayout>
);

export default CmSiteDetail;
